import React, { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { previewLots } from '../api/procurementPreview';
import type { SearchAlertFilters } from '../api/searchAlerts';
import { LotListItem, fmtAmount } from '../api/lots';
import { useLanguage } from '../context/LanguageContext';
import { procurementTrialCopy } from '../locales/procurementTrial';
import { PreviewLotRow } from './ProcurementPreview';

export default function SearchAlertPreview({ filters, name }: { filters: SearchAlertFilters; name: string }) {
  const { language } = useLanguage(); const copy = procurementTrialCopy[language];
  const [items, setItems] = useState<LotListItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [failed, setFailed] = useState(false);
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    const controller = new AbortController(); setLoading(true); setFailed(false);
    previewLots({ ...filters, sort: 'newest' }, controller.signal).then(result => { if (!controller.signal.aborted) setItems(result.items.slice(0, 3)); })
      .catch(() => { if (!controller.signal.aborted) setFailed(true); }).finally(() => { if (!controller.signal.aborted) setLoading(false); });
    return () => controller.abort();
  }, [filters, retry]);
  const example = items[0];
  const lotName = example && (language === 'kk' ? example.nameKz || example.nameRu : example.nameRu || example.nameKz);
  const code = example && (Array.isArray(example.enstruCode) ? example.enstruCode.join(', ') : example.enstruCode);
  return <div className="space-y-4">
    <section><h3 className="font-semibold text-slate-900">{copy.recentTitle}</h3><p className="mt-2 text-sm leading-6 text-slate-600">{copy.recentHint}</p>
      {loading ? <p role="status" className="mt-3"><Loader2 aria-label={copy.loading} className="h-4 w-4 animate-spin" /></p>
        : failed ? <p className="mt-3 text-sm text-slate-600">{copy.failed} <button className="font-semibold underline" onClick={() => setRetry(value => value + 1)}>{copy.retry}</button></p>
        : items.length ? <div className="mt-3 space-y-3">{items.map(lot => <PreviewLotRow key={lot.id} lot={lot} />)}</div> : <p className="mt-3 text-sm text-slate-600">{copy.recentEmpty}</p>}
    </section>
    <section className="rounded-2xl border border-slate-200 bg-slate-50 p-4"><h3 className="text-sm font-semibold text-slate-900">{copy.sampleTitle}</h3><p className="mt-1 text-xs leading-5 text-slate-500">{copy.sampleHint}</p>
      <div className="mt-3 space-y-2 rounded-xl bg-white p-4 text-sm [overflow-wrap:anywhere]"><p className="font-bold">{name || copy.sampleFilter}</p><p>{copy.sampleCategory}: {code || '—'}</p>
        <p>{lotName || copy.sampleFilter}</p><p>{copy.sampleAnnouncement}: {example?.trdBuyNumberAnno || '…'}</p><p>{copy.sampleAmount}: {example ? `${fmtAmount(example.amount)} ₸` : '… ₸'}</p><span className="block font-medium text-sky-700">{copy.sampleLink}</span>
      </div>
    </section>
  </div>;
}
